import React from "react";
import AudioPlayer from "./Audio";

export default function Phonetic(props) {
  //recieve from Results, styling in Results
  //console.log(props.phonetics);

  return (
    <div className="Phonetic d-flex align-items-center mt-1 mb-1">
      {props.phonetics.map(function (phonetic, index) {
        //mapping meening list
        if (phonetic.audio && phonetic.text) {
          //display block only when both audo and phonetic text exist, we ignore empty lines
          return (
            //use flex few times to align block with audio nicely
            <div
              className="ps-3 phonetics d-flex flex-wrap align-items-center"
              key={index}
            >
              <div>
                <AudioPlayer audio={phonetic.audio} />
              </div>
              <div className="ps-2 ">{phonetic.text}</div>
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}
